module.exports = __webpack_public_path__ + "static/media/home3.adcfd48c.jpg";